var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-radio-group', {
    attrs: {
      "row": "",
      "data-test-form-isCompany": ""
    },
    model: {
      value: _vm.isCompany,
      callback: function callback($$v) {
        _vm.isCompany = $$v;
      },
      expression: "isCompany"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.corporateClient'),
      "value": true,
      "data-test-form-iscompany": ""
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.private'),
      "value": false,
      "data-test-form-isprivate": ""
    }
  })], 1), _vm.isCompany ? _c('v-form', {
    ref: "chargingStationForm",
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('h3', [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgChargingStationForm.chargingStationOperaterTitle")) + " ")])]), _c('v-text-field', {
    attrs: {
      "value": _vm.chargingPointOperator.name,
      "label": _vm.$t('components.thg.ThgChargingStationForm.chargingpointOperaterName'),
      "hint": _vm.$t('components.thg.ThgChargingStationForm.chargingpointOperaterNameHint'),
      "rules": _vm.requiredRule,
      "required": "",
      "outlined": "",
      "data-test-form-company": ""
    }
  }), _c('v-card-text', [_c('h3', [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgChargingStationForm.chargingStationLocationTitle")) + " ")])]), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.street'),
      "hint": _vm.$t('components.thg.ThgChargingStationForm.addressHint'),
      "required": "",
      "outlined": "",
      "data-test-form-street": ""
    },
    model: {
      value: _vm.chargingStation.address.street,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation.address, "street", $$v);
      },
      expression: "chargingStation.address.street"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.germanZipRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.zip'),
      "hint": _vm.$t('components.thg.ThgChargingStationForm.addressHint'),
      "required": "",
      "outlined": "",
      "data-test-form-zip": ""
    },
    model: {
      value: _vm.chargingStation.address.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation.address, "zip", $$v);
      },
      expression: "chargingStation.address.zip"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.city'),
      "hint": _vm.$t('components.thg.ThgChargingStationForm.addressHint'),
      "required": "",
      "type": "",
      "outlined": "",
      "data-test-form-city": ""
    },
    model: {
      value: _vm.chargingStation.address.city,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation.address, "city", $$v);
      },
      expression: "chargingStation.address.city"
    }
  }), _c('v-card-text', [_c('h3', [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgChargingStationForm.chargingStationData")) + " ")])]), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.name'),
      "hint": _vm.$t('components.thg.ThgChargingStationForm.nameHint'),
      "required": "",
      "outlined": "",
      "data-test-form-name": ""
    },
    model: {
      value: _vm.chargingStation.name,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation, "name", $$v);
      },
      expression: "chargingStation.name"
    }
  }), _c('v-card-text', {
    staticClass: "px-0 pb-0"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("components.thg.ThgChargingStationForm.commissioningDate")))])]), _c('v-row', {
    staticClass: "pb-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.day,
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.day'),
      "hint": _vm.$t('components.thg.ThgChargingStationForm.dayHint'),
      "persistent-hint": "",
      "outlined": "",
      "data-test-form-commissioningDate-day": ""
    },
    model: {
      value: _vm.selectedDay,
      callback: function callback($$v) {
        _vm.selectedDay = $$v;
      },
      expression: "selectedDay"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.month'),
      "hint": _vm.$t('components.thg.ThgChargingStationForm.monthHint'),
      "persistent-hint": "",
      "items": _vm.month,
      "outlined": "",
      "data-test-form-commissioningDate-month": ""
    },
    model: {
      value: _vm.selectedMonth,
      callback: function callback($$v) {
        _vm.selectedMonth = $$v;
      },
      expression: "selectedMonth"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.year'),
      "hint": _vm.$t('components.thg.ThgChargingStationForm.yearHint'),
      "persistent-hint": "",
      "items": _vm.year,
      "outlined": "",
      "data-test-form-commissioningDate-year": ""
    },
    model: {
      value: _vm.selectedYear,
      callback: function callback($$v) {
        _vm.selectedYear = $$v;
      },
      expression: "selectedYear"
    }
  })], 1)], 1), _c('v-card-text', {
    staticClass: "px-0 pb-0"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("components.thg.ThgChargingStationForm.connectionDescription")))])]), _c('v-slider', {
    staticClass: "mt-8 mb-4 align-center",
    attrs: {
      "label": _vm.$t('components.thg.ThgChargingStationForm.chargingPointCount'),
      "hint": _vm.$t('components.thg.ThgChargingStationForm.chargingPointCountHint'),
      "persistent-hint": "",
      "rules": _vm.chargingPointNumberRule,
      "min": _vm.minChargingPointAmount,
      "max": _vm.maxChargingPointAmount,
      "type": "number",
      "thumb-label": "always"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-text-field', {
          staticClass: "mt-0 pt-0",
          staticStyle: {
            "width": "80px"
          },
          attrs: {
            "rules": _vm.chargingPointNumberRule,
            "type": "number",
            "min": _vm.minChargingPointAmount,
            "max": _vm.maxChargingPointAmount,
            "outlined": "",
            "data-test-form-charging-point-count": ""
          },
          model: {
            value: _vm.chargingStation.chargingPointCount,
            callback: function callback($$v) {
              _vm.$set(_vm.chargingStation, "chargingPointCount", $$v);
            },
            expression: "chargingStation.chargingPointCount"
          }
        })];
      },
      proxy: true
    }], null, false, 1457389817),
    model: {
      value: _vm.chargingStation.chargingPointCount,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation, "chargingPointCount", $$v);
      },
      expression: "chargingStation.chargingPointCount"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.connectionPowerRule,
      "min": _vm.minConnectionPower,
      "label": _vm.$t('components.thg.ThgChargingStationForm.connectionPowerInKwh'),
      "hint": _vm.$t('components.thg.ThgChargingStationForm.connectionPowerInKwhHint'),
      "required": "",
      "outlined": "",
      "type": "number",
      "thumb-label": "always",
      "suffix": "kWh",
      "data-test-form-connection-power": ""
    },
    model: {
      value: _vm.chargingStation.connectionPowerInKwh,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation, "connectionPowerInKwh", $$v);
      },
      expression: "chargingStation.connectionPowerInKwh"
    }
  }), _c('v-select', {
    staticClass: "mb-8 pt-4",
    attrs: {
      "items": _vm.isRegisteredItems,
      "persistent-hint": "",
      "label": _vm.$t('components.thg.ThgChargingStationForm.isRegistered'),
      "hint": _vm.$t('components.thg.ThgChargingStationForm.isRegisteredHint'),
      "outlined": "",
      "data-test-form-registered": ""
    },
    model: {
      value: _vm.chargingStation.isRegistered,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation, "isRegistered", $$v);
      },
      expression: "chargingStation.isRegistered"
    }
  }), _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid,
      "data-test-form-submit": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgChargingStationForm.submit")) + " ")])], 1)], 1) : _vm._e(), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [!_vm.isCompany ? _c('v-card-text', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('components.thg.ThgChargingStationForm.isPrivatePerson'))
    }
  })]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }